import React, { useState, useEffect } from "react";
import BoardingPointArrayComponent from "./BoardingPointArrayComponent";
import DroppingPointArrayComponent from "./DroppingPointArrayComponent";



const StopsComponent = (props) => {

  const [boarding, setboarding] = useState(true);
  const [amount, setamount] = useState();


  useEffect(() => {

    setamount(props?.seatsClicked?.reduce((a, c) => a + c.seatPrice, 0))



  }, [props.seatsClicked]);

  return (
    <>
      <div className="lg:w-[35%]">
        <p className="font-semibold text-sm mt-3">THIS BOOKING IS NOT REFUNDABLE</p>
        <p className="mt-3 text-sm">
          This booking falls under the 100% cancellation charges window of the
          cancellation policy
        </p>
        <div className="bg-[#fff] mt-4 mb-2">
          <div className="flex   ">
            <p
              className={
                boarding
                  ? "text-lg text-center bg-[#00b0ff] cursor-pointer p-5 px-9"
                  : "text-lg text-center cursor-pointer bg-[#fff]   p-5 px-9"
              }
              onClick={() => setboarding(true)}
            >
              Boarding Point
            </p>
            <p
              className={
                boarding
                  ? "text-lg  text-center cursor-pointer bg-[#fff] p-5 px-9"
                  : "text-lg text-center bg-[#00b0ff] cursor-pointer p-5 px-9"
              }
              onClick={() => setboarding(false)}
            >
              Dropping Point
            </p>
          </div>
          <hr />
          {boarding ? (
            <BoardingPointArrayComponent
              addBoardingPoint={props.addBoardingPoint}
              selectedBoardingPoint={props.newBooking?.boardingPoint}

              stops={props.boardingPoint}
            />
          ) : (
            <DroppingPointArrayComponent

              addDroppingPoint={props.addDroppingPoint}
              selectedDroppingPoint={props.newBooking.droppingPoint}


              stops={props.droppingPoint}
            />
          )}
          <div className="flex justify-between px-4 py-4 text-xl">
            <p className="text-lg text-gray-400 ">Amount</p>
            <p className="font-bold">INR {amount}</p>
          </div>
          <div className="ml-4 mr-4 mb-4">
            <button
              onClick={() => props.showSummaryFunction(true)}
              className="bg-blue-500 text-white p-auto w-[100%] mb-4 py-2 text-lg"
            >
              Continue
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default StopsComponent;
